import { fetcherWithBody } from 'services/fetcher';
import { apiUrls } from 'services/api-urls';
import { CustomerType } from 'types/Customer';

export async function subscribe(
  postData: SubscribeNewsletterType
): Promise<Response> {
  const data = { ...postData, evt: 'newsletter', sendMailNewsletter: true };

  return fetcherWithBody(apiUrls.getCustomerUpdate(), data, true);
}

export async function unsubscribe(
  postData: UnsubscribeNewsletter
): Promise<Response> {
  return fetcherWithBody(
    apiUrls.getCustomerNewsletterUnsubscribe(),
    postData,
    true
  );
}

type SubscribeNewsletterType = Pick<
  CustomerType,
  | 'email'
  | 'civility'
  | 'lastName'
  | 'firstName'
  | 'cellPhone'
  | 'mailOption'
  | 'smsOption'
  | 'partOption'
> & {
  turnstileToken: string;
};

type UnsubscribeNewsletter = Pick<
  CustomerType,
  'email' | 'mailOption' | 'smsOption' | 'partOption'
> & {
  turnstileToken: string;
};
